import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/api/queryKeys";
import type { DataResponse } from "@/api/schemas";

/** Koľko času strávil jeden autor na jednej zákazke. */
export interface SuhrnPrace {
  autor: string;
  sekundy: number;
  relacii: number;
  prvy: string;
  posledny: string;
}

export interface PracaZakazky {
  zakazka_id: string;
  sekundy_celkom: number;
  podla_autora: SuhrnPrace[];
}

export interface PracaPrehladItem extends PracaZakazky {
  cislo_zakazky: string;
  nazov: string | null;
}

export interface PulzVysledok {
  sekundy_relacie: number;
  sekundy_autora: number;
}

/**
 * Pulz z otvoreného editora.
 *
 * Zámerne **neinvaliduje žiadnu cache** — chodí každú minútu a refetch
 * veľkého payloadu zákazky pri každom pulze by z merania času urobil
 * najdrahšiu operáciu v aplikácii.
 */
export function usePulz(): UseMutationResult<
  DataResponse<PulzVysledok>,
  Error,
  string
> {
  return useMutation({
    mutationFn: async (zakazkaId: string) => {
      const { data } = await api.post<DataResponse<PulzVysledok>>(
        `/zakazky/${zakazkaId}/pulz`,
      );
      return data;
    },
    // Zmeškaný pulz nie je problém — ďalší príde do minúty
    retry: false,
  });
}

export function usePrehladPrace(
  enabled = true,
): UseQueryResult<DataResponse<PracaPrehladItem[]>> {
  return useQuery({
    queryKey: queryKeys.praca.prehlad(),
    queryFn: async () => {
      const { data } =
        await api.get<DataResponse<PracaPrehladItem[]>>("/praca");
      return data;
    },
    enabled,
  });
}
